import { render, staticRenderFns } from "./PhysiologyData.vue?vue&type=template&id=49dab106&scoped=true"
import script from "./PhysiologyData.vue?vue&type=script&lang=js"
export * from "./PhysiologyData.vue?vue&type=script&lang=js"
import style0 from "./PhysiologyData.vue?vue&type=style&index=0&id=49dab106&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dab106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49dab106')) {
      api.createRecord('49dab106', component.options)
    } else {
      api.reload('49dab106', component.options)
    }
    module.hot.accept("./PhysiologyData.vue?vue&type=template&id=49dab106&scoped=true", function () {
      api.rerender('49dab106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/athetes/healthRecords/PhysiologyData.vue"
export default component.exports